export default (offsetX, chartInstance, filter = { xAxisIndex: 0 }) => {
  const xAxisVlaue = chartInstance.convertFromPixel(filter, offsetX);
  return [xAxisVlaue, offsetX];
};
